<template>
  <div class="c-detail-product-image">
    <img
      :src="imageSrc"
      class="c-detail-product-image--background"
      @error="loadPlaceholder"
    >
    <div class="o-container u-px-25">
      <img
        v-if="!backgroundOnly"
        :alt="product.title"
        :src="imageSrc"
        class="c-detail-product-image--main"
      >
    </div>
  </div>
</template>
<script>
  import { ImageType } from '@/shared/enums';
  import { imageCoverMixin } from '@/index/shared/mixins';

  export default {
    mixins: [
      imageCoverMixin,
    ],
    props: {
      product: Object,
      backgroundOnly: Boolean,
      type: {
        type: String,
        default: ImageType.COVER_MINI,
      },
    },
  };
</script>
